import MainLayout from "../layout/main-layout";
import WebDevelopmentHeadSection from "../Components/web-development/web-development-head-section";
import WebDevelopmentBenefits from "../Components/web-development/web-development-benefits";
import WebDevelopmentProcess from "../Components/web-development/web-development-process";
import WhyChooseWebDevelopment from "../Components/web-development/why-choose-web-development";
import WebDevelopmentContact from "../Components/web-development/web-development-contact";
import { useRef } from "react";

function WebDevelopment() {
  const contactRef = useRef<HTMLDivElement>(null);
  
    const handleScrollToContact = () => {
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  
  return (
    <div>
      <MainLayout>
        <WebDevelopmentHeadSection onScroll={handleScrollToContact} />
        <WebDevelopmentBenefits />
        <WebDevelopmentProcess />
        <WhyChooseWebDevelopment />
        <WebDevelopmentContact contactRef={contactRef} />
      </MainLayout>
    </div>
  );
}

export default WebDevelopment;
